import type { DuplicateUsersDto, EmailUpdateDto, GetIdentityUsersExtnInput } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { IdentityUserDto } from '@volo/abp.ng.identity/proxy';

@Injectable({
  providedIn: 'root',
})
export class IdentityUserExtnService {
  apiName = 'Default';
  

  checkUserEmail = (emailAddresses?: string[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>({
      method: 'POST',
      url: '/api/app/identity-user-extn/check-user-email',
      body: emailAddresses,
    },
    { apiName: this.apiName,...config });
  

  deleteUser = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'DELETE',
      url: `/api/app/identity-user-extn/delete/${id}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IdentityUserDto>({
      method: 'GET',
      url: `/api/app/identity-user-extn/${id}`,
    },
    { apiName: this.apiName,...config });

    getBookingUser = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IdentityUserDto>({
      method: 'GET',
      url: `/api/app/identity-user-extn/${id}/booking-user`,
    },
    { apiName: this.apiName,...config });
  

  getAllInvalidUsersByEmailAddresses = (emailAddresses?: string[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, DuplicateUsersDto[]>({
      method: 'GET',
      url: '/api/app/identity-user-extn/invalid-users',
      params: { emailAddresses },
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetIdentityUsersExtnInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdentityUserDto>>({
      method: 'GET',
      url: '/api/app/identity-user-extn',
      params: { membershipNumber: input.membershipNumber, filter: input.filter, roleId: input.roleId, organizationUnitId: input.organizationUnitId, userName: input.userName, phoneNumber: input.phoneNumber, emailAddress: input.emailAddress, name: input.name, surname: input.surname, isLockedOut: input.isLockedOut, notActive: input.notActive, emailConfirmed: input.emailConfirmed, isExternal: input.isExternal, maxCreationTime: input.maxCreationTime, minCreationTime: input.minCreationTime, maxModifitionTime: input.maxModifitionTime, minModifitionTime: input.minModifitionTime, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount, extraProperties: input.extraProperties },
    },
    { apiName: this.apiName,...config });
  

  merge = (toBeDeletedId: string, survivingUserId: string, comments: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: '/api/app/identity-user-extn/merge',
      params: { toBeDeletedId, survivingUserId, comments },
    },
    { apiName: this.apiName,...config });
  

  sendDuplicateAccountNotificationsByEmailAddresses = (emailAddresses: string[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: '/api/app/identity-user-extn/send-duplicate-account-notifications',
      body: emailAddresses,
    },
    { apiName: this.apiName,...config });
  

  updateUserEmails = (emailUpdates: EmailUpdateDto[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: '/api/app/identity-user-extn/update-user-emails',
      body: emailUpdates,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
